// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","PlusBadge":"bcp_a bha_qn bha_qo bha_ua bha_cy bha_ty bha_gm bha_ka"};